<template lang="pug">
transition-group.messages-container(name='message', tag='div')
  div(
    v-for='message in activeMessages',
    :key='message.id',
    :class='["message-alert", `message-${message.type}`]'
  )
    .message-content
      i(:class='getIconClass(message.type)')
      span {{ message.content }}
    button.message-close(type='button', aria-label='Cerrar', @click='removeMessage(message.id)')
      i.pi.pi-times
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useMessagesStore } from '@/stores/messages';

export default {
  name: 'Messages',
  computed: {
    ...mapState(useMessagesStore, ['activeMessages']),
  },
  methods: {
    ...mapActions(useMessagesStore, ['removeMessage']),

    getIconClass(type) {
      const icons = {
        error: 'pi pi-times-circle',
        success: 'pi pi-check-circle',
        warning: 'pi pi-exclamation-triangle',
        info: 'pi pi-info-circle',
      };
      return icons[type] || icons.info;
    },
  },
};
</script>

<style scoped>
.messages-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 420px;
  width: 100%;
}

.message-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem 1rem;
  border-radius: var(--escality-radius-lg);
  box-shadow: var(--escality-shadow-lg);
  animation: slideIn 0.3s ease;
  font-size: var(--escality-text-base);
}

.message-error {
  background: var(--escality-danger-50);
  border-left: 4px solid var(--escality-danger);
  color: var(--escality-danger-text);
}

.message-success {
  background: var(--escality-success-50);
  border-left: 4px solid var(--escality-success);
  color: var(--escality-success-text);
}

.message-warning {
  background: var(--escality-warning-50);
  border-left: 4px solid var(--escality-warning);
  color: var(--escality-warning-text);
}

.message-info {
  background: var(--escality-primary-100);
  border-left: 4px solid var(--escality-primary);
  color: var(--escality-primary-dark);
}

.message-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
}

.message-content i {
  font-size: var(--escality-text-lg);
  flex-shrink: 0;
}

.message-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  margin-left: 0.5rem;
  opacity: 0.6;
  transition: opacity 0.2s;
  color: inherit;
}

.message-close:hover {
  opacity: 1;
}

/* Animaciones */
.message-enter-active {
  animation: slideIn 0.3s ease;
}

.message-leave-active {
  animation: slideOut 0.3s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}
</style>
